core.service('stringUtils', [
    function () {
        this.formatString = function (format, args) {
            return format.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            });
        };

        this.formatJSONDate = function(date) {
            var result = new Date(date.getTime());
            result.setHours(result.getHours() - result.getTimezoneOffset() / 60);
            return result.toJSON();
        };

        this.formatCustomDate = function(date) {
            var result = moment(date);
            return result.format('YYYY-MM-DDTHH:mm:ss.SSZ');
        };

        this.toBoolean = function(source) {
            return ((source + '').toLowerCase() === 'true' ? true : false);
        };

        this.toUnderscore = function(text) {
            return text.replace(/([A-Z])/g, function($1) {
                return '_' + $1.toLowerCase();
            });
        };
    }
]);
